import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { Subject } from 'rxjs';
import { IstStudyTeamOrganizationViewModalComponent } from '../../ist-study-team-organization/ist-study-team-organization-view-modal/ist-study-team-organization-view-modal.component';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { DatePipe } from '@angular/common'
import { UserService } from '../../../../services/user.service';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject } from 'src/app/models/common';

@Component({
  selector: 'app-all-requests-view-modal',
  templateUrl: './all-requests-view-modal.component.html',
  styleUrls: ['./all-requests-view-modal.component.scss']
})
export class AllRequestsViewModalComponent implements OnInit {

  @Input() public Content: any;
  formFields;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  ProductRequestForm: UntypedFormGroup;
  recurrence: any;
  shippingAddress: any;
  billingAddress: any;
  isNewMode: boolean = true;
  minDate:Date = new Date();
  DateOFExpiresminDate : Date 
  EndsONminDate : Date 
  RequiredByminDate : Date 
  maxDate: Date = new Date();
  disabledPresentDate = [
    new Date()
  ];
  ApplicationID: any;
  SelectedWeeksList: any = [];
  userType: string = "";
  RetrivalLabel: string = "";
  AddPlusRequired: boolean;
  disabledDates: Date[] = [];
  QuantityUnits = [
    {
      "label": "Tablets",
      "value": "Tablets"
    },
    {
      "label": "Capsules",
      "value": "Capsules"
    },
    {
      "label": "Strips",
      "value": "Strips"
    },
    {
      "label": "Syrup",
      "value": "Syrup"
    },
    {
      "label": "Inhailer",
      "value": "Inhailer"
    }
  ];
  dosageFormulaOptions = [];
  optionsSelect = [];
  statusOptions = [];
  productNamesOptions = [];
  strengthValuesOptions = [
    {
      "label": "25",
      "value": 1
    },
    {
      "label": "50",
      "value": 2
    },
    {
      "label": "75",
      "value": 3
    }
  ];
  strengthAndUnitsOptions = [];
  ProductsMappedInfoList = [];
  SelectedProductsMappedInfoList = [];
  fullFillmentTypeOptions = [];
  patientIdOptions = [];
  shippingAddressOptions = [];
  ProductshippingAddressOptions = [];
  usedQuan: string;
  recurrenceOptions = [];
  repeatsEveryOptions = [];
  returnAmount: string;
  public StatusStr = "";
  parentId: any;
  myDate = new Date(new Date().getTime() - (24 * 60 * 60 * 1000));
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth();
  Day = this.myDate.getDate();


  IsRequiredDateModified: boolean = false;
  REQUIRED_DATE: DateObject;
  CurrentDate: Date;
  EndDateModified: boolean = false;
  END_DATE: DateObject;
  ManufactureDateModified: boolean = false;
  MANUFACTURE_DATE: DateObject;
  ExpiryDateModified: boolean = false;
  EXPIRY_DATE: DateObject;
  DispatchDateModified: boolean = false;
  DISPATCH_DATE: DateObject;
  ShipDispatchDateModified: boolean = false;
  staticformFields: any;
  SHIP_DISPATCH_DATE: DateObject;

  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private datashareService: IstDataShareService,
    public datepipe: DatePipe,
    private userService: UserService,
    private commonService: CommonService
  ) { }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        if(this.staticformFields?.REQUIRED_ON_DATE.IS_PASTDATES_ALLOWED)
          this.RequiredByminDate = new Date()
        if(this.staticformFields?.END_ON_DATE.IS_PASTDATES_ALLOWED)
          this.EndsONminDate = new Date()
        if(this.staticformFields?.EXPIRY_DATE.IS_PASTDATES_ALLOWED)
          this.DateOFExpiresminDate = new Date()
      });
  }

  ngOnInit() {

    // this.RequiredByminDate = new Date();
    // this.DateOFExpiresminDate = new Date();
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.getStaticFiledsData('SCR-007');
    this.recurrenceOptions = [
      {
        "label": "Daily",
        "value": "Daily"
      },
      {
        "label": "Weekly",
        "value": "Weekly"
      },
      {
        "label": "Monthly",
        "value": "Monthly"
      },
      {
        "label": "Yearly",
        "value": "Yearly"
      },
    ];
    this.repeatsEveryOptions = [
      {
        "label": "Monday",
        "value": "1"
      },
      {
        "label": "Tuesday",
        "value": "2"
      },
      {
        "label": "Wednesday",
        "value": "3"
      },
      {
        "label": "Thursday",
        "value": "4"
      },
      {
        "label": "Friday",
        "value": "5"
      },
      {
        "label": "Saturday",
        "value": "6"
      },
      {
        "label": "Sunday",
        "value": "7"
      }

    ];
    this.recurrenceOptions = [{ label: "Select", value: null, checked: true }].concat(this.recurrenceOptions);
    this.AddPlusRequired = true;
    this.returnAmount = this.Content.content.ReturnAmount;
   
    this.userType = this.userService.getUserType();

    this.summaryService.getSummaryData("api/ISTAllRequests/GetProductMasterDropData?ApplicationID=" + this.ApplicationID + "&RecordID=" + this.Content.content.id).subscribe(result => {
      this.productNamesOptions = result["MasterData1"];
      this.productNamesOptions = [{ label: "Select", value: null, checked: true }].concat(this.productNamesOptions);
      this.dosageFormulaOptions = result["MasterData2"];
      this.strengthAndUnitsOptions = result["MasterData3"];
      this.patientIdOptions = result["MasterData4"];
      this.shippingAddressOptions = result["MasterData5"];
      this.shippingAddressOptions = [{ label: "Select", value: null, checked: true }].concat(this.shippingAddressOptions);
      this.ProductsMappedInfoList = result["ProductDropdown"];
      if (result["MasterData6"] != null && result["MasterData6"] != undefined) {
        var data = this.ProductsMappedInfoList.filter(x => x.value == result["MasterData6"][0].value)[0];
        if (data != null && data != undefined) {

          if (data.ISAllowShipmentToReporter) {
            this.fullFillmentTypeOptions = [{ "label": "Shipping Address", "value": 1 }];
          }

          this.fullFillmentTypeOptions.push({ "label": "Partner Network", "value": 2 });

          this.SelectedProductsMappedInfoList = data.MappedNetworks;
          this.ProductRequestForm.controls["ShippingInstractionsIfAny"].setValue(data.StorageInstructions);
          this.ProductRequestForm.controls["RequiredQuantityUnits"].setValue(data.ProductUnits);
          this.ProductRequestForm.controls["AllocatedQuantityUnits"].setValue(data.ProductUnits);
          this.ProductRequestForm.controls["UsedQuantityUnits"].setValue(data.ProductUnits);
          this.ProductRequestForm.controls["ReturnQuantityUnits"].setValue(data.ProductUnits);
          this.ProductRequestForm.controls["ShippingInstractionsIfAny"].disable();
          this.ProductRequestForm.controls["RequiredQuantityUnits"].disable();
          this.ProductRequestForm.controls["AllocatedQuantityUnits"].disable();
          this.ProductRequestForm.controls["UsedQuantityUnits"].disable();
          this.ProductRequestForm.controls["ReturnQuantityUnits"].disable();
        }

      }


      if (this.Content.heading != "Add") {
// this.ProductRequestForm.controls['IsEndsOn'].disable();
// this.ProductRequestForm.controls['ISnoOfOccurances'].disable();
        this.getProductInfo();
        
      }
      else {
        this.StatusStr = "Draft";
      }
    });

    this.ProductRequestForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      Application_ID: new UntypedFormControl(null),
      DosageFormul: new UntypedFormControl(null),
      ProductName: new UntypedFormControl(null),
      Strength: new UntypedFormControl(null),
      StrengthUnits: new UntypedFormControl(null),
      RequiredBy: new UntypedFormControl(null),
      RequiredOnO: new UntypedFormControl(null),
      FullFillmentType: new UntypedFormControl(null),
      PaitientID: new UntypedFormControl(null),
      BillingAddress: new UntypedFormControl(null),
      ShippingAddress: new UntypedFormControl(null),
      Recurrence: new UntypedFormControl(null),
      RepeatsEvery: new UntypedFormControl(null),
      IsEndsOn: new UntypedFormControl(null),
      ISnoOfOccurances: new UntypedFormControl(null),
      EndsON: new UntypedFormControl(null),
      EndsONO: new UntypedFormControl(null),
      AfterNoOfOccurrences: new UntypedFormControl(null),
      AllocatedQuantity: new UntypedFormControl(null),
      AllocatedQuantityUnits: new UntypedFormControl(null),
      ShipmentTrackingID: new UntypedFormControl(null),
      ShipmentSericeProvider: new UntypedFormControl(null),
      BatchNumber: new UntypedFormControl(null),
      DateOfManufature: new UntypedFormControl(null),
      DateOfManufatureO: new UntypedFormControl(null),
      DateOFExpires: new UntypedFormControl(null),
      DateOFExpiresO: new UntypedFormControl(null),
      DateOFDispatch: new UntypedFormControl(null),
      DateOFDispatchO: new UntypedFormControl(null),
      ShippingnsrucionsIFAny: new UntypedFormControl(null),
      RequiredQuantity: new UntypedFormControl(null),
      RequiredQuantityUnits: new UntypedFormControl(null),
      UsedQuantity: new UntypedFormControl(null),
      UsedQuantityUnits: new UntypedFormControl(null),
      DateOFRecept: new UntypedFormControl(null),
      ReturnQuantity: new UntypedFormControl(null),
      ReturnQuantityUnits: new UntypedFormControl(null),
      ShipmentNumber: new UntypedFormControl(null),
      returnShipmentServiceProvider: new UntypedFormControl(null),
      returnDateOFDispatch: new UntypedFormControl(null),
      returnDateOFDispatchO: new UntypedFormControl(null),
      returnDateOfRecept: new UntypedFormControl(null),
      Notes: new UntypedFormControl(null),
      ShippingInstractionsIfAny: new UntypedFormControl(null),
      Status: new UntypedFormControl(0)
    });

    if (this.returnAmount != null && this.returnAmount != undefined) {
      this.ProductRequestForm.controls["ReturnQuantity"].disable();
    }

    this.ProductRequestForm.controls["IsEndsOn"].disable();
    this.ProductRequestForm.controls["ISnoOfOccurances"].disable();
    this.ProductRequestForm.controls["EndsON"].disable();
    this.ProductRequestForm.controls["AfterNoOfOccurrences"].disable();
  }

  onRequiredSelect(event) {
    this.IsRequiredDateModified = true;
    this.REQUIRED_DATE = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.IsRequiredDateModified,
    }
  }

  GetRequiredDate(): DateObject {
    const formModel = this.ProductRequestForm.getRawValue();
    const date = new Date(formModel.RequiredBy);
    if (this.ComparingDates(this.CurrentDate, date) || this.REQUIRED_DATE == null || this.REQUIRED_DATE == undefined) {
      this.REQUIRED_DATE = {
        Day: date.getDate(),
        Month: (date.getMonth() + 1),
        Year: date.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    return this.REQUIRED_DATE;
  }

  onEndDate(event) {
    this.EndDateModified = true;
    this.END_DATE = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.EndDateModified,
    }
  }

  GetEndDate(): DateObject {
    const formModel = this.ProductRequestForm.getRawValue();
    const date = new Date(formModel.EndsON);
    if (this.ComparingDates(this.CurrentDate, date) || this.END_DATE == null || this.END_DATE == undefined) {
      this.END_DATE = {
        Day: date.getDate(),
        Month: (date.getMonth() + 1),
        Year: date.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    return this.END_DATE;
  }

  onManufactureDate(event) {
    this.ManufactureDateModified = true;
    this.MANUFACTURE_DATE = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.ManufactureDateModified,
    }
  }

  GetManufactureDate(): DateObject {
    const formModel = this.ProductRequestForm.getRawValue();
    const date = new Date(formModel.DateOfManufature);
    if (this.ComparingDates(this.CurrentDate, date) || this.MANUFACTURE_DATE == null || this.MANUFACTURE_DATE == undefined) {
      this.MANUFACTURE_DATE = {
        Day: date.getDate(),
        Month: (date.getMonth() + 1),
        Year: date.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    return this.MANUFACTURE_DATE;
  }

  onExpiryDate(event) {
    this.ExpiryDateModified = true;
    this.EXPIRY_DATE = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.ExpiryDateModified,
    }
  }

  GetExpiryDate(): DateObject {
    const formModel = this.ProductRequestForm.getRawValue();
    const date = new Date(formModel.DateOFExpires);
    if (this.ComparingDates(this.CurrentDate, date) || this.EXPIRY_DATE == null || this.EXPIRY_DATE == undefined) {
      this.EXPIRY_DATE = {
        Day: date.getDate(),
        Month: (date.getMonth() + 1),
        Year: date.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    return this.EXPIRY_DATE;
  }

  onDispatchDate(event) {
    this.DispatchDateModified = true;
    this.DISPATCH_DATE = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.DispatchDateModified,
    }
  }

  GetDispatchDate(): DateObject {
    const formModel = this.ProductRequestForm.getRawValue();
    const date = new Date(formModel.DateOFDispatch);
    if (this.ComparingDates(this.CurrentDate, date) || this.DISPATCH_DATE == null || this.DISPATCH_DATE == undefined) {
      this.DISPATCH_DATE = {
        Day: date.getDate(),
        Month: (date.getMonth() + 1),
        Year: date.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    return this.DISPATCH_DATE;
  }

  onShipmentDispatchDate(event) {
    this.ShipDispatchDateModified = true;
    this.SHIP_DISPATCH_DATE = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.ShipDispatchDateModified,
    }
  }

  GetShipDispatchDate(): DateObject {
    const formModel = this.ProductRequestForm.getRawValue();
    const date = new Date(formModel.returnDateOFDispatch);
    if (this.ComparingDates(this.CurrentDate, date) || this.SHIP_DISPATCH_DATE == null || this.SHIP_DISPATCH_DATE == undefined) {
      this.SHIP_DISPATCH_DATE = {
        Day: date.getDate(),
        Month: (date.getMonth() + 1),
        Year: date.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    return this.SHIP_DISPATCH_DATE;
  }

  ComparingDates(oldDate: any, newDate: any) {
    if (oldDate != undefined && oldDate != null && oldDate != '') {
      let oDt = oldDate.getDate().toString() + oldDate.getMonth().toString() + oldDate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt)
        return true;
      else
        return false;
    }
    else
      return false;
  }

  getProductInfo() {
    this.summaryService.getScreenDataForEdit("api/ISTAllRequests/EditProduct?RecordID=" + this.Content.content.id).subscribe((result: any) => {
      if (result != null) {
        this.StatusStr = result["StatusStr"];
        this.RetrivalLabel = result["RetrivalLabel"];
        var formtedData = this.dataFormateMethod(result);
        this.usedQuan = result["UsedQuantity"];
        this.parentId = result["ParentId"];

        setTimeout(() => {
          this.ShippingAddressChange(result["ShippingAddress"]);
          this.BillingAddressChange(result["BillingAddress"]);

          document.body.click();
        }, 2000)

        //  this.ProductRequestForm.patchValue(formtedData);
        setTimeout(()=>{
        this.ProductRequestForm.patchValue({
          ID: formtedData["ID"],
          Application_ID: formtedData["Application_ID"],
          DosageFormul: formtedData["DosageFormul"],
          ProductName: formtedData["ProductName"],
          Strength: formtedData["Strength"],
          StrengthUnits: formtedData["StrengthUnits"],
          RequiredBy: formtedData["RequiredBy"],
          FullFillmentType: formtedData["FullFillmentType"],
          PaitientID: formtedData["PaitientID"],
          BillingAddress: formtedData["BillingAddress"],
          ShippingAddress: formtedData["ShippingAddress"],
          Recurrence: formtedData["Recurrence"],
          RepeatsEvery: formtedData["RepeatsEvery"],
          IsEndsOn: formtedData["IsEndsOn"],
          ISnoOfOccurances: formtedData["ISnoOfOccurances"],
          EndsON: formtedData["EndsON"],
          AfterNoOfOccurrences: formtedData["AfterNoOfOccurrences"],
          AllocatedQuantity: formtedData["AllocatedQuantity"],
          // AllocatedQuantityUnits: formtedData["ID"],
          ShipmentTrackingID: formtedData["ShipmentTrackingID"],
          ShipmentSericeProvider: formtedData["ShipmentSericeProvider"],
          BatchNumber: formtedData["BatchNumber"],
          DateOfManufature: formtedData["DateOfManufature"],
          DateOFExpires: formtedData["DateOFExpires"],
          DateOFDispatch: formtedData["DateOFDispatch"],
          // ShippingnsrucionsIFAny: formtedData["ID"],
          RequiredQuantity: formtedData["RequiredQuantity"],
          // RequiredQuantityUnits: formtedData["ID"],
          UsedQuantity: formtedData["UsedQuantity"],
          //  UsedQuantityUnits: formtedData["ID"],
          DateOFRecept: formtedData["DateOFRecept"],
          //ReturnQuantity: formtedData["ReturnQuantity"],
          //  ReturnQuantityUnits: formtedData["ID"],
          ShipmentNumber: formtedData["ShipmentNumber"],
          returnShipmentServiceProvider: formtedData["returnShipmentServiceProvider"],
          returnDateOFDispatch: formtedData["returnDateOFDispatch"],
          returnDateOfRecept: formtedData["returnDateOfRecept"],
          Notes: formtedData["Notes"],
          ShippingInstractionsIfAny: formtedData["ShippingInstractionsIfAny"],
          Status: formtedData["Status"],
        });
        
        this.ProductRequestForm.controls["IsEndsOn"].disable();
        this.ProductRequestForm.controls["ISnoOfOccurances"].disable();
        this.ProductRequestForm.controls["EndsON"].disable();
        }, 0); 
        this.ProductRequestForm.controls['EndsON'].setValue(formtedData["EndsON"]);

        if (this.returnAmount != undefined) {
          this.ProductRequestForm.controls['UsedQuantity'].disable();
        }

        if (this.parentId != undefined && this.parentId != null && this.parentId != "") {
          this.ProductRequestForm.controls["ProductName"].disable();
          this.ProductRequestForm.controls["RequiredQuantity"].disable();
          // this.ProductRequestForm.controls["RequiredBy"].disable();
          this.ProductRequestForm.controls["FullFillmentType"].disable();
          this.ProductRequestForm.controls["ShippingAddress"].disable();
          this.ProductRequestForm.controls["BillingAddress"].disable();
        }

        this.ProductRequestForm.controls["Recurrence"].disable();
        this.ProductRequestForm.controls["IsEndsOn"].disable();
        this.ProductRequestForm.controls["ISnoOfOccurances"].disable();
        this.ProductRequestForm.controls["EndsON"].disable();
        this.ProductRequestForm.controls["AfterNoOfOccurrences"].disable();
        this.ProductRequestForm.controls['ReturnQuantity'].setValue(this.returnAmount);
        this.ProductChange(formtedData["ProductName"], formtedData["FullFillmentType"]);
        this.disabledControls(result["Status"], formtedData);

        this.extendedForm.rowid = result["ID"];
        this.extendedForm.getResponse();
      }
    });
  }

  ChangeValue(data) {
    if (data.currentTarget.id == "ISnoOfOccurances") {
      this.ProductRequestForm.controls["ISnoOfOccurances"].setValue("Yes");
      this.ProductRequestForm.controls["IsEndsOn"].setValue("No");
      this.ProductRequestForm.controls["EndsON"].disable();
      this.ProductRequestForm.controls["AfterNoOfOccurrences"].enable();
    } else if (data.currentTarget.id == "IsEndsOn") {
      this.ProductRequestForm.controls["IsEndsOn"].setValue("Yes");
      this.ProductRequestForm.controls["ISnoOfOccurances"].setValue("No");
      this.ProductRequestForm.controls["AfterNoOfOccurrences"].disable();
      this.ProductRequestForm.controls["EndsON"].enable();
    }

    if (this.ProductRequestForm.controls["IsEndsOn"].value == "Yes") {
      this.ProductRequestForm.controls["AfterNoOfOccurrences"].disable();
      this.ProductRequestForm.controls["AfterNoOfOccurrences"].setValue("");
    } else {
      this.ProductRequestForm.controls["EndsON"].disable();
      this.ProductRequestForm.controls["EndsON"].setValue("");
    }
  }

  change(data) {
    if (this.ProductRequestForm.controls["Recurrence"].value == undefined) {
      this.ProductRequestForm.controls["IsEndsOn"].disable();
      this.ProductRequestForm.controls["ISnoOfOccurances"].disable();
      this.ProductRequestForm.controls["EndsON"].disable();
      this.ProductRequestForm.controls["AfterNoOfOccurrences"].disable();
    } else {
      this.ProductRequestForm.controls["IsEndsOn"].enable();
      this.ProductRequestForm.controls["ISnoOfOccurances"].enable();
      //this.ProductRequestForm.controls["EndsON"].enable();
      //this.ProductRequestForm.controls["AfterNoOfOccurrences"].enable();
    }
  }

  dataFormateMethod(formData: any) {
    let today = new Date(); today.setHours(0,0,0,0)
    if (formData != null) {
      if (formData["RequiredBy"] != null && formData["RequiredBy"] != undefined) {

        formData["RequiredBy"] = this.commonService.getdisplayedDate(formData["RequiredBy"]);

                  let date = new Date(formData["RequiredBy"]);
                  setTimeout(()=>{
                    while (date < today) {
                      this.disabledDates.push(new Date(date));
                      date.setDate(date.getDate() + 1);}
                  },1000);
                  if(formData["RequiredBy"] < today)
                    this.RequiredByminDate = formData["RequiredBy"];
                  else{
                    this.RequiredByminDate = today;
                  }

      }
      if (formData["EndsON"] != null && formData["EndsON"] != undefined) {
        formData["EndsON"] = this.commonService.getdisplayedDate(formData["EndsON"]);
            let date = new Date(formData["EndsON"]);
            setTimeout(()=>{
              while (date < today) {
                this.disabledDates.push(new Date(date));
                date.setDate(date.getDate() + 1);}
            },1000);
            setTimeout(()=>{
              if(formData["EndsON"] < today)
                this.EndsONminDate = formData["EndsON"]
              else{
                this.EndsONminDate = today;
              }
            },0);
      }
      if (formData["DateOfManufature"] != null && formData["DateOfManufature"] != undefined) {
        formData["DateOfManufature"] = this.commonService.getdisplayedDate(formData["DateOfManufature"]);
      }
      if (formData["DateOFExpires"] != null && formData["DateOFExpires"] != undefined) {
        formData["DateOFExpires"] = this.commonService.getdisplayedDate(formData["DateOFExpires"]);
        if(formData["DateOFExpires"] < new Date())
          this.DateOFExpiresminDate = formData["DateOFExpires"]
      }
      if (formData["DateOFDispatch"] != null && formData["DateOFDispatch"] != undefined) {
        formData["DateOFDispatch"] = this.commonService.getdisplayedDate(formData["DateOFDispatch"]);
      }
      if (formData["DateOFRecept"] != null && formData["DateOFRecept"] != undefined) {

        formData["DateOFRecept"] = this.commonService.getdisplayedDate(formData["DateOFRecept"]);
      }
      if (formData["returnDateOFDispatch"] != null && formData["returnDateOFDispatch"] != undefined) {

        formData["returnDateOFDispatch"] = this.commonService.getdisplayedDate(formData["returnDateOFDispatch"]);
      }
      if (formData["returnDateOfRecept"] != null && formData["returnDateOfRecept"] != undefined) {
        //  formData["returnDateOfRecept"] = this.datepipe.transform(formData["returnDateOfRecept"], 'dd-MMM-yyyy');
        formData["returnDateOfRecept"] = this.commonService.getdisplayedDate(formData["returnDateOfRecept"]);
      }

    }
    return formData;
  }

  disabledControls(status: any, formtedData: any) {

    if (status == 5) {
      this.ProductRequestForm.controls["AllocatedQuantity"].disable();
      this.ProductRequestForm.controls["AllocatedQuantityUnits"].disable();
      this.ProductRequestForm.controls["ShipmentTrackingID"].disable();
      this.ProductRequestForm.controls["ShipmentSericeProvider"].disable();

      this.ProductRequestForm.controls["BatchNumber"].disable();
      this.ProductRequestForm.controls["DateOfManufature"].disable();
      this.ProductRequestForm.controls["DateOFExpires"].disable();

      //this.ProductRequestForm.controls["ShippingInstractionsIfAny"].disable();
      this.ProductRequestForm.controls["DateOFDispatch"].disable();
      this.AddPlusRequired = false;

    }
    if (status == 7 || status == 8 || status == 4) {
      this.ProductRequestForm.disable();
      this.Content.heading = "View";
      this.AddPlusRequired = false;
    }
    if (status > 1) {
      this.ProductRequestForm.controls["ProductName"].disable();
      this.ProductRequestForm.controls["DosageFormul"].disable();
      this.ProductRequestForm.controls["Strength"].disable();
      this.ProductRequestForm.controls["StrengthUnits"].disable();
      this.ProductRequestForm.controls["RequiredQuantity"].disable();
      this.ProductRequestForm.controls["RequiredQuantity"].disable();
      this.ProductRequestForm.controls["RequiredQuantityUnits"].disable();
      this.ProductRequestForm.controls["RequiredBy"].disable();
      this.ProductRequestForm.controls["FullFillmentType"].disable();
      this.ProductRequestForm.controls["PaitientID"].disable();
      this.ProductRequestForm.controls["ShippingAddress"].disable();
      this.ProductRequestForm.controls["BillingAddress"].disable();
      this.ProductRequestForm.controls["Recurrence"].disable();
      // this.ProductRequestForm.controls["IsEndsOn"].disable();
      // this.ProductRequestForm.controls["ISnoOfOccurances"].disable();
      this.ProductRequestForm.controls["EndsON"].disable();
      this.ProductRequestForm.controls["AfterNoOfOccurrences"].disable();
      this.AddPlusRequired = false;

    }
    if (this.userType == "I") {
      this.ProductRequestForm.controls["UsedQuantity"].disable();
      this.ProductRequestForm.controls["UsedQuantityUnits"].disable();
      this.ProductRequestForm.controls["DateOFRecept"].disable();
      this.ProductRequestForm.controls["ReturnQuantity"].disable();
      this.ProductRequestForm.controls["ReturnQuantityUnits"].disable();
      this.ProductRequestForm.controls["returnShipmentServiceProvider"].disable();
      this.ProductRequestForm.controls["ShipmentNumber"].disable();
      this.ProductRequestForm.controls["Notes"].disable();
      if (status == 3) {
        this.ProductRequestForm.controls["ShippingInstractionsIfAny"].enable();
      }
      if (formtedData.ReturnQuantity != null && formtedData.ReturnQuantity != undefined)
        this.ProductRequestForm.controls["returnDateOfRecept"].enable();
      else
        this.ProductRequestForm.controls["returnDateOfRecept"].disable();
    }
    else {
      this.ProductRequestForm.controls["returnDateOfRecept"].disable();
      this.ProductRequestForm.controls["AllocatedQuantity"].disable();
      this.ProductRequestForm.controls["AllocatedQuantityUnits"].disable();
      this.ProductRequestForm.controls["ShipmentTrackingID"].disable();
      this.ProductRequestForm.controls["ShipmentSericeProvider"].disable();
      this.ProductRequestForm.controls["BatchNumber"].disable();
      this.ProductRequestForm.controls["DateOfManufature"].disable();
      this.ProductRequestForm.controls["DateOFExpires"].disable();
      this.ProductRequestForm.controls["DateOFDispatch"].disable();
      this.ProductRequestForm.controls["ShippingnsrucionsIFAny"].disable();
    }

    if (this.Content.heading == "View") {
      this.ProductRequestForm.disable();
    }
  }

  addNewOrg() {
    let modalRef = this['self'].modalService.open(IstStudyTeamOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: "", ApplicationID: "" },

    }
    modalRef.result.then(result => {
      this.summaryService.getSummaryData("api/ISTAllRequests/GetProductMasterDropData?ApplicationID=" + this.ApplicationID).subscribe(result => {
        this.shippingAddressOptions = result["MasterData5"];
      });
    })
  }

  SaveProductInfo() {

    if (this.validateControls()) {
      var formData = this.ProductRequestForm.value;
      formData["Application_ID"] = this.ApplicationID;
      formData["Recurrence"] = this.ProductRequestForm.controls["Recurrence"].value;
      formData["ProductName"] = this.ProductRequestForm.controls["ProductName"].value;
      formData["RequiredQuantityUnits"] = this.ProductRequestForm.controls["RequiredQuantityUnits"].value;
      formData["AllocatedQuantityUnits"] = this.ProductRequestForm.controls["AllocatedQuantityUnits"].value;
      formData["UsedQuantityUnits"] = this.ProductRequestForm.controls["UsedQuantityUnits"].value;
      formData["ReturnQuantityUnits"] = this.ProductRequestForm.controls["ReturnQuantityUnits"].value;
      formData["EndsON"] = this.ProductRequestForm.controls["EndsON"].value;
      formData["AfterNoOfOccurrences"] = this.ProductRequestForm.controls["AfterNoOfOccurrences"].value;
      formData["RepeatsEvery"] = this.ProductRequestForm.controls["RepeatsEvery"].value;
      formData["ShippingAddress"] = this.ProductRequestForm.controls["ShippingAddress"].value;
      formData["BillingAddress"] = this.ProductRequestForm.controls["BillingAddress"].value;
      formData["FullFillmentType"] = this.ProductRequestForm.controls["FullFillmentType"].value;
      formData["EndsOnDate"] = this.ProductRequestForm.controls["EndsON"].value;
      formData["RequiredOn"] = this.ProductRequestForm.controls["RequiredBy"].value;
      formData["ReturnQuantity"] = this.ProductRequestForm.controls["ReturnQuantity"].value;

      formData["ShipmentSericeProvider"]=this.ProductRequestForm.controls["ShipmentSericeProvider"].value;
      formData["ShipmentSericeProvider"] = formData["ShipmentSericeProvider"] == null?null : formData["ShipmentSericeProvider"] == undefined? undefined:formData["ShipmentSericeProvider"].trim();
     
      formData["ShipmentTrackingID"]= this.ProductRequestForm.controls["ShipmentTrackingID"].value;
      formData["ShipmentTrackingID"] = formData["ShipmentTrackingID"] == null?null : formData["ShipmentTrackingID"] == undefined? undefined:formData["ShipmentTrackingID"].trim();
     
      formData["ShippingInstractionsIfAny"]= this.ProductRequestForm.controls["ShippingInstractionsIfAny"].value;
      formData["ShippingInstractionsIfAny"] = formData["ShippingInstractionsIfAny"] == null?null : formData["ShippingInstractionsIfAny"] == undefined? undefined:formData["ShippingInstractionsIfAny"].trim(); 

      formData["ShipmentNumber"]= this.ProductRequestForm.controls["ShipmentNumber"].value;
      formData["ShipmentNumber"] = formData["ShipmentNumber"] == null?null : formData["ShipmentNumber"] == undefined? undefined:formData["ShipmentNumber"].trim(); 

      formData["returnShipmentServiceProvider"]= this.ProductRequestForm.controls["returnShipmentServiceProvider"].value;
      formData["returnShipmentServiceProvider"] = formData["returnShipmentServiceProvider"] == null?null : formData["returnShipmentServiceProvider"] == undefined? undefined:formData["returnShipmentServiceProvider"].trim(); 

      formData["Notes"]= this.ProductRequestForm.controls["Notes"].value;
      formData["Notes"] = formData["Notes"] == null?null : formData["Notes"] == undefined? undefined:formData["Notes"].trim(); 


      if (formData["RequiredOn"] != null && formData["RequiredOn"] != undefined && formData["RequiredOn"] != "") {
        const date = this.GetRequiredDate();
        formData["RequiredOnO"] = date;
      }

      if (formData["EndsON"] != null && formData["EndsON"] != undefined && formData["EndsON"] != "") {
        const endDate = this.GetEndDate();
        formData["EndsONO"] = endDate;
      }

      if (formData["FullFillmentType"] != null && formData["FullFillmentType"] != undefined) {
        formData["FullFillmentType"] = parseInt(formData["FullFillmentType"]);
      }
      if (formData["AllocatedQuantity"] != null && formData["AllocatedQuantity"] != undefined) {
        formData["AllocatedQuantity"] = parseInt(formData["AllocatedQuantity"]);
      }
      if (formData["RequiredQuantity"] != null && formData["RequiredQuantity"] != undefined) {
        formData["RequiredQuantity"] = parseInt(formData["RequiredQuantity"]);
      }
      if (formData["UsedQuantity"] == null && formData["UsedQuantity"] == undefined && this.StatusStr == "Request Returned") {
        formData["UsedQuantity"] = 0;
      }
      if (formData["UsedQuantity"] != null && formData["UsedQuantity"] != undefined) {
        formData["UsedQuantity"] = parseInt(formData["UsedQuantity"]);
      }
      if (formData["ReturnQuantity"] != null && formData["ReturnQuantity"] != undefined) {
        formData["ReturnQuantity"] = parseInt(formData["ReturnQuantity"]);
      }

      if (formData["RequiredBy"] != null && formData["RequiredBy"] != undefined) {
        const ldate = new Date(formData["RequiredBy"]);
        formData["RequiredBy"] = new Date(formData["RequiredBy"]);
        formData["STR_RequiredBy"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
      }

      if (formData["EndsON"] != null && formData["EndsON"] != undefined) {
        const ldate = new Date(formData["EndsON"]);
        formData["EndsON"] = new Date(formData["EndsON"]);
        formData["STR_EndsON"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
      }

      if (formData["DateOfManufature"] != null && formData["DateOfManufature"] != undefined) {
        formData["DateOfManufature"] = new Date(formData["DateOfManufature"]);
        const ldate = new Date(formData["DateOfManufature"]);
        formData["STR_DateOfManufature"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
      }
      formData["DateOfManufatureO"] = this.GetManufactureDate();
      if (formData["DateOFExpires"] != null && formData["DateOFExpires"] != undefined) {
        formData["DateOFExpires"] = new Date(formData["DateOFExpires"]);
        const ldate = new Date(formData["DateOFExpires"]);
        formData["STR_DateOFExpires"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
      }
      formData["DateOFExpiresO"] = this.GetExpiryDate();

      if (formData["DateOFDispatch"] != null && formData["DateOFDispatch"] != undefined) {
        formData["DateOFDispatch"] = new Date(formData["DateOFDispatch"]);
        const ldate = new Date(formData["DateOFDispatch"]);
        formData["STR_DateOFDispatch"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
      }
      formData["DateOFDispatchO"] = this.GetDispatchDate();

      if (formData["DateOFRecept"] != null && formData["DateOFRecept"] != undefined) {
        formData["DateOFRecept"] = new Date(formData["DateOFRecept"]);
        const ldate = new Date(formData["DateOFRecept"]);
        formData["STR_DateOFRecept"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
      }

      if (formData["returnDateOFDispatch"] != null && formData["returnDateOFDispatch"] != undefined) {
        formData["returnDateOFDispatch"] = new Date(formData["returnDateOFDispatch"]);
        const ldate = new Date(formData["returnDateOFDispatch"]);
        formData["STR_returnDateOFDispatch"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
      }
      formData["returnDateOFDispatchO"] = this.GetShipDispatchDate();

      if (formData["returnDateOfRecept"] != null && formData["returnDateOfRecept"] != undefined) {
        formData["returnDateOfRecept"] = new Date(formData["returnDateOfRecept"]);
        const ldate = new Date(formData["returnDateOfRecept"]);
        formData["STR_returnDateOfRecept"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
      }

      if (formData["IsEndsOn"] == "Yes") {
        formData["IsEndsOn"] = "Yes";
      }
      else {
        formData["IsEndsOn"] = "No";
      }

      if (formData["ISnoOfOccurances"] == "No") {
        formData["ISnoOfOccurances"] = "No";
      }
      else {
        formData["ISnoOfOccurances"] = "Yes";
      }

      formData["SelectedWeeks"] = this.SelectedWeeksList.join(",");
      if (this.Content.heading === 'Add') {
        this.summaryService.Insert("api/ISTAllRequests/InsertProduct", formData).subscribe(result => {
          if (result.Status == 0) {
            if (result.Data.length > 0) {
              result.Data.forEach((ele: any) => {
                this.ProductRequestForm.controls["ID"].setValue(ele.TransactionID);
                this.extendedForm.saveControls(ele.TransactionID, this.ApplicationID, ele.TransactionCode).subscribe(result1 => {
                });
              });
              this.commonService.SuccessBanner("Product request added successfully");
              // this.action.next();
              this.modalRef.close();
            }
          }
        });
      } else if (this.Content.heading === 'Edit' || this.Content.heading === 'Allocate' || this.Content.heading === 'Return') {
        this.summaryService.Insert("api/ISTAllRequests/UpdateProduct", formData).subscribe(result => {
          if (result.Status == 0) {
            this.ProductRequestForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              this.commonService.SuccessBanner("Request details updated successfully");
              // this.action.next(result);
              this.modalRef.close(result);
            });
          } else {
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.ErrorCode == "NOCONTROLS" && result.ErrorCode == "NOCHANGES") {
                this.commonService.ValidationBanner(result.Message);
              }
              else {
                if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  this.commonService.SuccessBanner("Request details updated successfully");
                  //this.action.next(formData);
                  this.modalRef.close(formData);
                }
              }
            });
          }

        });
      }
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.ProductRequestForm.value;
    formData["Recurrence"] = this.ProductRequestForm.controls["Recurrence"].value;

    //ProductName
    if (this.staticformFields?.PRODUCT_ID.IS_Display) {
      if (this.staticformFields?.PRODUCT_ID.IS_MANDATORY
        && (formData.ProductName === null || formData.ProductName === "")) {

        $("#ProductName").addClass("ng-touched ng-invalid validate-error");
        $("#ProductName").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.PRODUCT_ID.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#ProductName").addClass("ng-untouched ng-valid");
        $("#ProductName").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    //RequiredQuantity
    if (this.staticformFields?.REQUIRED_QUANTITY.IS_Display) {
      if ((formData.RequiredQuantity === null || formData.RequiredQuantity === "") && this.staticformFields?.REQUIRED_QUANTITY.IS_MANDATORY) {
        $("#RequiredQuantity").addClass("ng-touched ng-invalid validate-error");
        $("#RequiredQuantity").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUIRED_QUANTITY.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#RequiredQuantity").addClass("ng-untouched ng-valid");
        $("#RequiredQuantity").removeClass("ng-touched ng-invalid validate-error");
      }

      if (formData.RequiredQuantity !== null && formData.RequiredQuantity !== "" && formData.RequiredQuantity !== undefined) {
        const phoneformat = /^[1-9]\d*$/;
        formData.RequiredQuantity = formData.RequiredQuantity + "";
        if (formData.RequiredQuantity.match(phoneformat)) {
          $("#RequiredQuantity").addClass("ng-untouched ng-valid");
          $("#RequiredQuantity").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#RequiredQuantity").addClass("ng-touched ng-invalid validate-error");
          $("#RequiredQuantity").removeClass("ng-untouched ng-valid");
          message += `Please enter valid ${this.staticformFields?.REQUIRED_QUANTITY.LABEL_NAME}<br/>`;
          isValid = false;
        }
      }
    }

    //RequiredBy
    if (this.staticformFields?.REQUIRED_ON_DATE.IS_Display && this.staticformFields?.REQUIRED_ON_DATE.IS_MANDATORY) {
      if (formData.RequiredBy === null || formData.RequiredBy === "") {
        $("#RequiredBy").addClass("ng-touched ng-invalid validate-error");
        $("#RequiredBy").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUIRED_ON_DATE.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#RequiredBy").addClass("ng-untouched ng-valid");
        $("#RequiredBy").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    //FullFillmentType
    if (this.staticformFields?.FULFILMENT_TYPE.IS_Display && this.staticformFields?.FULFILMENT_TYPE.IS_MANDATORY
      && this.staticformFields?.PRODUCT_ID.IS_Display) {
      if (formData.FullFillmentType === null || formData.FullFillmentType === "") {
        $("#FullFillmentType").addClass("ng-touched ng-invalid validate-error");
        $("#FullFillmentType").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.FULFILMENT_TYPE.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#FullFillmentType").addClass("ng-untouched ng-valid");
        $("#FullFillmentType").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    //ShippingAddress
    if (this.staticformFields?.FULFILMENT_TYPE.IS_Display && this.staticformFields?.SHIPPING_ORGANIZATION_ID.IS_Display && this.staticformFields?.SHIPPING_ORGANIZATION_ID.IS_MANDATORY) {
      if (formData.ShippingAddress === null || formData.ShippingAddress === "") {
        $("#ShippingAddress").addClass("ng-touched ng-invalid validate-error");
        $("#ShippingAddress").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.SHIPPING_ORGANIZATION_ID.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#ShippingAddress").addClass("ng-untouched ng-valid");
        $("#ShippingAddress").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    //BillingAddress
    if (this.staticformFields?.BILLING_ORGANIZATION_ID.IS_Display && this.staticformFields?.BILLING_ORGANIZATION_ID.IS_MANDATORY) {
      if (formData.BillingAddress === null || formData.BillingAddress === "") {
        $("#BillingAddress").addClass("ng-touched ng-invalid validate-error");
        $("#BillingAddress").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.BILLING_ORGANIZATION_ID.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#BillingAddress").addClass("ng-untouched ng-valid");
        $("#BillingAddress").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    //Recurrence
    if (this.parentId == undefined && this.staticformFields?.RECURRENCE_ID.IS_Display
      && this.staticformFields?.RECURRENCE_ID.IS_MANDATORY && formData['Status'] == 0) {
      if (formData.Recurrence === null || formData.Recurrence === "" || formData.Recurrence === undefined) {
        $("#Recurrence").addClass("ng-touched ng-invalid validate-error");
        $("#Recurrence").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.RECURRENCE_ID.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#Recurrence").addClass("ng-untouched ng-valid");
        $("#Recurrence").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (formData.Recurrence != undefined) {

      //RepeatsEvery
      if (formData.Recurrence == '1' && this.staticformFields?.REPEAT_EVERY_ID.IS_Display
        && this.staticformFields?.REPEAT_EVERY_ID.IS_MANDATORY) {
        if (formData.RepeatsEvery === null || formData.RepeatsEvery === "") {
          $("#RepeatsEvery").addClass("ng-touched ng-invalid validate-error");
          $("#RepeatsEvery").removeClass("ng-untouched ng-valid");
          message += `Please select ${this.staticformFields?.REPEAT_EVERY_ID.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#RepeatsEvery").addClass("ng-untouched ng-valid");
          $("#RepeatsEvery").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      //EndsON and AfterNoOfOccurrences
      if (this.staticformFields?.END_ON_DATE.IS_Display && this.staticformFields?.AFTER_NO_OF_OCCURENCE.IS_Display
        && this.staticformFields?.END_ON_DATE.IS_MANDATORY && this.staticformFields?.AFTER_NO_OF_OCCURENCE.IS_MANDATORY && this.staticformFields?.RECURRENCE_ID.IS_Display) {
        if ((formData.IsEndsOn === null || formData.IsEndsOn === "")
          && (formData.ISnoOfOccurances === null || formData.ISnoOfOccurances === "")) {
          message += `Please select ${this.staticformFields?.END_ON_DATE.LABEL_NAME}/${this.staticformFields?.AFTER_NO_OF_OCCURENCE.LABEL_NAME}<br/>`;
          isValid = false;
        }
      } else {
        //EndsON
        if (this.staticformFields?.END_ON_DATE.IS_Display && this.staticformFields?.END_ON_DATE.IS_MANDATORY && this.staticformFields?.RECURRENCE_ID.IS_Display) {
          if (formData.IsEndsOn === "Yes" && (formData.EndsON === null || formData.EndsON === "" || formData.EndsON === undefined)) {
            $("#EndsON").addClass("ng-touched ng-invalid validate-error");
            $("#EndsON").removeClass("ng-untouched ng-valid");
            message += `Please select ${this.staticformFields?.END_ON_DATE.LABEL_NAME}<br/>`;
            isValid = false;
          } else {
            $("#EndsON").addClass("ng-untouched ng-valid");
            $("#EndsON").removeClass("ng-touched ng-invalid validate-error");
          }
        }

        //AfterNoOfOccurrences
        if (this.staticformFields?.AFTER_NO_OF_OCCURENCE.IS_Display && this.staticformFields?.AFTER_NO_OF_OCCURENCE.IS_MANDATORY
          && this.staticformFields?.RECURRENCE_ID.IS_Display) {
          if (formData.ISnoOfOccurances === "Yes" && (formData.AfterNoOfOccurrences === null
            || formData.AfterNoOfOccurrences === "" || formData.AfterNoOfOccurrences === undefined)) {
            $("#AfterNoOfOccurrences").addClass("ng-touched ng-invalid validate-error");
            $("#AfterNoOfOccurrences").removeClass("ng-untouched ng-valid");
            message += `Please enter ${this.staticformFields?.AFTER_NO_OF_OCCURENCE.LABEL_NAME}<br/>`;
            isValid = false;
          } else {
            $("#AfterNoOfOccurrences").addClass("ng-untouched ng-valid");
            $("#AfterNoOfOccurrences").removeClass("ng-touched ng-invalid validate-error");
          }
        }
      }
    }
    //Notes

    if (formData['Status'] == 3) {

      formData.AllocatedQuantity = $("#AllocatedQuantity").val();
      //AllocatedQuantity
      if (this.staticformFields?.ALLOCATED_QUANTITY.IS_Display) {
        if ((formData.AllocatedQuantity === null || formData.AllocatedQuantity === "" || formData.AllocatedQuantity === undefined)
          && this.staticformFields?.ALLOCATED_QUANTITY.IS_MANDATORY) {
          $("#AllocatedQuantity").addClass("ng-touched ng-invalid validate-error");
          $("#AllocatedQuantity").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.ALLOCATED_QUANTITY.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#AllocatedQuantity").addClass("ng-untouched ng-valid");
          $("#AllocatedQuantity").removeClass("ng-touched ng-invalid validate-error");
        }

        if (formData.AllocatedQuantity !== null && formData.AllocatedQuantity !== "" && formData.AllocatedQuantity !== undefined) {
          const phoneformat = /^[1-9]\d*$/;
          formData.AllocatedQuantity = formData.AllocatedQuantity + "";
          if (formData.AllocatedQuantity.match(phoneformat)) {
            $("#AllocatedQuantity").addClass("ng-untouched ng-valid");
            $("#AllocatedQuantity").removeClass("ng-touched ng-invalid validate-error");
          }
          else {
            $("#AllocatedQuantity").addClass("ng-touched ng-invalid validate-error");
            $("#AllocatedQuantity").removeClass("ng-untouched ng-valid");
            message += `Please enter Valid ${this.staticformFields?.ALLOCATED_QUANTITY.LABEL_NAME}<br/>`;
            isValid = false;
          }

          var quantity = this.ProductRequestForm.controls["RequiredQuantity"].value;
          if (quantity != null && quantity != undefined) {
            var Reqquantity1 = parseFloat(quantity);
            var Allquantity1 = parseFloat(formData.AllocatedQuantity);
            if (Allquantity1 > Reqquantity1) {
              $("#AllocatedQuantity").addClass("ng-touched ng-invalid validate-error");
              $("#AllocatedQuantity").removeClass("ng-untouched ng-valid");
              message += `${this.staticformFields?.ALLOCATED_QUANTITY.LABEL_NAME} should not greater than ${this.staticformFields?.REQUIRED_QUANTITY.LABEL_NAME}<br/>`;
              isValid = false;
            }
          }
        }
      }
      //ShipmentTrackingID
      if (this.staticformFields?.SHIPPING_TRACKING_ID.IS_Display && this.staticformFields?.SHIPPING_TRACKING_ID.IS_MANDATORY) {
        if (formData.ShipmentTrackingID === null || formData.ShipmentTrackingID === "" || formData.ShipmentTrackingID === undefined) {
          $("#ShipmentTrackingID").addClass("ng-touched ng-invalid validate-error");
          $("#ShipmentTrackingID").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.SHIPPING_TRACKING_ID.LABEL_NAME}<br/>`;
          isValid = false;
        } else if(formData.ShipmentTrackingID != null && formData.ShipmentTrackingID != undefined && formData.ShipmentTrackingID.trim()==""){
          $("#ShipmentTrackingID").addClass("ng-touched ng-invalid validate-error");
          $("#ShipmentTrackingID").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.SHIPPING_TRACKING_ID.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#ShipmentTrackingID").addClass("ng-untouched ng-valid");
          $("#ShipmentTrackingID").removeClass("ng-touched ng-invalid validate-error");
        }
      }
      //ShipmentSericeProvider
      if (this.staticformFields?.SERVICE_PROVIDER.IS_Display && this.staticformFields?.SERVICE_PROVIDER.IS_MANDATORY) {
        if (formData.ShipmentSericeProvider === null || formData.ShipmentSericeProvider === "" || formData.ShipmentSericeProvider === undefined) {
          $("#ShipmentSericeProvider").addClass("ng-touched ng-invalid validate-error");
          $("#ShipmentSericeProvider").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.SERVICE_PROVIDER.LABEL_NAME}<br/>`;
          isValid = false;
        } else if(formData.ShipmentSericeProvider != null && formData.ShipmentSericeProvider != undefined && formData.ShipmentSericeProvider.trim()==""){
          $("#ShipmentSericeProvider").addClass("ng-touched ng-invalid validate-error");
          $("#ShipmentSericeProvider").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.SERVICE_PROVIDER.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#ShipmentSericeProvider").addClass("ng-untouched ng-valid");
          $("#ShipmentSericeProvider").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      //DateOfManufature
      if (this.staticformFields?.MANUFACTURE_DATE.IS_Display && this.staticformFields?.MANUFACTURE_DATE.IS_MANDATORY) {
        if (formData.DateOfManufature === null || formData.DateOfManufature === "" || formData.DateOfManufature === undefined) {
          $("#DateOfManufature").addClass("ng-touched ng-invalid validate-error");
          $("#DateOfManufature").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.MANUFACTURE_DATE.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#DateOfManufature").addClass("ng-untouched ng-valid");
          $("#DateOfManufature").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      //DateOFExpires
      if (this.staticformFields?.EXPIRY_DATE.IS_Display && this.staticformFields?.EXPIRY_DATE.IS_MANDATORY) {
        if (formData.DateOFExpires === null || formData.DateOFExpires === "" || formData.DateOFExpires === undefined) {
          $("#DateOFExpires").addClass("ng-touched ng-invalid validate-error");
          $("#DateOFExpires").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.EXPIRY_DATE.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#DateOFExpires").addClass("ng-untouched ng-valid");
          $("#DateOFExpires").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      //ShippingInstractionsIfAny
      if (this.staticformFields?.STORAGE_INSTRUCTION.IS_Display && this.staticformFields?.STORAGE_INSTRUCTION.IS_MANDATORY) {
        if (formData.ShippingInstractionsIfAny === null || formData.ShippingInstractionsIfAny === "" || formData.ShippingInstractionsIfAny === undefined) {
          $("#ShippingInstractionsIfAny").addClass("ng-touched ng-invalid validate-error");
          $("#ShippingInstractionsIfAny").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.STORAGE_INSTRUCTION.LABEL_NAME}<br/>`;
          isValid = false;
        } else if(formData.ShippingInstractionsIfAny != null && formData.ShippingInstractionsIfAny != undefined && formData.ShippingInstractionsIfAny.trim()==""){
          $("#ShippingInstractionsIfAny").addClass("ng-touched ng-invalid validate-error");
          $("#ShippingInstractionsIfAny").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.STORAGE_INSTRUCTION.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#ShippingInstractionsIfAny").addClass("ng-untouched ng-valid");
          $("#ShippingInstractionsIfAny").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      //DateOFDispatch
      if (this.staticformFields?.DISPATCH_DATE.IS_Display && this.staticformFields?.DISPATCH_DATE.IS_MANDATORY) {
        if (formData.DateOFDispatch === null || formData.DateOFDispatch === "" || formData.DateOFDispatch === undefined) {
          $("#DateOFDispatch").addClass("ng-touched ng-invalid validate-error");
          $("#DateOFDispatch").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.DISPATCH_DATE.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#DateOFDispatch").addClass("ng-untouched ng-valid");
          $("#DateOFDispatch").removeClass("ng-touched ng-invalid validate-error");
        }
      }

    }

    if (formData['Status'] == 5 || formData['Status'] == 10) {
      var UsedQuantity = this.ProductRequestForm.controls["UsedQuantity"].value;
      if (this.staticformFields?.USED_QUANTITY.IS_Display) {
        if ((UsedQuantity === null || UsedQuantity === "" || UsedQuantity === undefined)
          && this.staticformFields?.USED_QUANTITY.IS_MANDATORY) {
          $("#UsedQuantity").addClass("ng-touched ng-invalid validate-error");
          $("#UsedQuantity").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.USED_QUANTITY.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#UsedQuantity").addClass("ng-untouched ng-valid");
          $("#UsedQuantity").removeClass("ng-touched ng-invalid validate-error");
        }

        if (formData.UsedQuantity !== null && formData.UsedQuantity !== "" && formData.UsedQuantity !== undefined) {
          var Allocated = $("#AllocatedQuantity").val();
          if (Allocated != null && Allocated != undefined) {
            var Allocated1 = parseFloat(Allocated);
            var used = parseFloat(formData.UsedQuantity);
            if (used > Allocated1) {
              $("#UsedQuantity").addClass("ng-touched ng-invalid validate-error");
              $("#UsedQuantity").removeClass("ng-untouched ng-valid");
              message += ` ${this.staticformFields?.USED_QUANTITY.LABEL_NAME} should not be greater than ${this.staticformFields?.ALLOCATED_QUANTITY.LABEL_NAME}<br/>`;
              isValid = false;
            }
          }
        }
      }

      if (this.StatusStr == 'Closed' || this.Content.heading == 'Return' || this.StatusStr == 'Returned' || this.StatusStr == 'withdrawn') {
        //ReturnQuantity
        var ReturnQuantity = this.ProductRequestForm.controls["ReturnQuantity"].value;

        if (this.staticformFields?.RETRIVE_RETURN_QUANTITY.IS_Display && this.staticformFields?.RETRIVE_RETURN_QUANTITY.IS_MANDATORY) {
          if (ReturnQuantity === null || ReturnQuantity === "" || ReturnQuantity === undefined) {
            $("#ReturnQuantity").addClass("ng-touched ng-invalid validate-error");
            $("#ReturnQuantity").removeClass("ng-untouched ng-valid");
            message += `Please enter ${this.staticformFields?.RETRIVE_RETURN_QUANTITY.LABEL_NAME}<br/>`;
            isValid = false;
          } else {
            $("#ReturnQuantity").addClass("ng-untouched ng-valid");
            $("#ReturnQuantity").removeClass("ng-touched ng-invalid validate-error");
          }
        }

        //ShipmentNumber
        if (this.staticformFields?.SHIPMENT_TRACKING_NO.IS_Display && this.staticformFields?.SHIPMENT_TRACKING_NO.IS_MANDATORY) {
          if (formData.ShipmentNumber === null || formData.ShipmentNumber === "" || formData.ShipmentNumber === undefined) {
            $("#ShipmentNumber").addClass("ng-touched ng-invalid validate-error");
            $("#ShipmentNumber").removeClass("ng-untouched ng-valid");
            message += `Please enter ${this.staticformFields?.SHIPMENT_TRACKING_NO.LABEL_NAME}<br/>`;
            isValid = false;
          } else if(formData.ShipmentNumber != null && formData.ShipmentNumber != undefined && formData.ShipmentNumber.trim()==""){
            $("#ShipmentNumber").addClass("ng-touched ng-invalid validate-error");
            $("#ShipmentNumber").removeClass("ng-untouched ng-valid");
            message += `Please enter ${this.staticformFields?.SHIPMENT_TRACKING_NO.LABEL_NAME}<br/>`;
            isValid = false;
          } else {
            $("#ShipmentNumber").addClass("ng-untouched ng-valid");
            $("#ShipmentNumber").removeClass("ng-touched ng-invalid validate-error");
          }
        }

        //returnShipmentServiceProvider
        if (this.staticformFields?.SHIPMENT_SERVICE_PROVIDER.IS_Display && this.staticformFields?.SHIPMENT_SERVICE_PROVIDER.IS_MANDATORY) {
          if (formData.returnShipmentServiceProvider === null || formData.returnShipmentServiceProvider === "" || formData.returnShipmentServiceProvider === undefined) {
            $("#returnShipmentServiceProvider").addClass("ng-touched ng-invalid validate-error");
            $("#returnShipmentServiceProvider").removeClass("ng-untouched ng-valid");
            message += `Please enter ${this.staticformFields?.SHIPMENT_SERVICE_PROVIDER.LABEL_NAME}<br/>`;
            isValid = false;
          } else if(formData.returnShipmentServiceProvider != null && formData.returnShipmentServiceProvider != undefined && formData.returnShipmentServiceProvider.trim()==""){
            $("#returnShipmentServiceProvider").addClass("ng-touched ng-invalid validate-error");
            $("#returnShipmentServiceProvider").removeClass("ng-untouched ng-valid");
            message += `Please enter ${this.staticformFields?.SHIPMENT_SERVICE_PROVIDER.LABEL_NAME}<br/>`;
            isValid = false;
          } else {
            $("#returnShipmentServiceProvider").addClass("ng-untouched ng-valid");
            $("#returnShipmentServiceProvider").removeClass("ng-touched ng-invalid validate-error");
          }
        }

        //returnDateOFDispatch
        if (this.staticformFields?.RETURN_DISPATCH_DATE.IS_Display && this.staticformFields?.RETURN_DISPATCH_DATE.IS_MANDATORY) {
          if (formData.returnDateOFDispatch === null || formData.returnDateOFDispatch === "" || formData.returnDateOFDispatch === undefined) {
            $("#returnDateOFDispatch").addClass("ng-touched ng-invalid validate-error");
            $("#returnDateOFDispatch").removeClass("ng-untouched ng-valid");
            message += `Please select ${this.staticformFields?.RETURN_DISPATCH_DATE.LABEL_NAME}<br/>`;
            isValid = false;
          } else {
            $("#returnDateOFDispatch").addClass("ng-untouched ng-valid");
            $("#returnDateOFDispatch").removeClass("ng-touched ng-invalid validate-error");
          }
        }

        if (this.staticformFields?.RETURN_NOTES.IS_Display && this.staticformFields?.RETURN_NOTES.IS_MANDATORY) {
          if (formData.Notes === null || formData.Notes === "" ) {
            $("#Notes").addClass("ng-touched ng-invalid validate-error");
            $("#Notes").removeClass("ng-untouched ng-valid");
            message += `Please enter ${this.staticformFields?.RETURN_NOTES.LABEL_NAME}<br/>`;
            isValid = false;
          } else if(formData.Notes!= null && formData.Notes != undefined && formData.Notes.trim()=="") {
            $("#Notes").addClass("ng-touched ng-invalid validate-error");
            $("#Notes").removeClass("ng-untouched ng-valid");
            message += `Please enter ${this.staticformFields?.RETURN_NOTES.LABEL_NAME}<br/>`;
            isValid = false;
          } else {
            $("#Notes").addClass("ng-untouched ng-valid");
            $("#Notes").removeClass("ng-touched ng-invalid validate-error");
          }
        }

      }
    }
    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      message = message + ExtenMsgs;
      isValid = false;
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);

    return isValid;
  }

  ShippingAddressChange(data1) {

    var data = this.ProductshippingAddressOptions.filter(x => x.value == data1)[0];
    var addressList = [];
    if (data != null && data != undefined) {
      if (data.label != null || data.label != undefined) {
        addressList = data.label.split(",");
      }
    }
    this.shippingAddress = new Object();
    this.shippingAddress["Address"] = "";
    this.shippingAddress["City"] = "";
    this.shippingAddress["State"] = "";
    this.shippingAddress["Country"] = "";
    this.shippingAddress["PostalCode"] = "";
    if (addressList.length > 0) {
      this.shippingAddress["Address"] = addressList[0];
      this.shippingAddress["City"] = addressList[1];
      this.shippingAddress["State"] = addressList[2];
      this.shippingAddress["Country"] = addressList[3];
      this.shippingAddress["PostalCode"] = addressList[4];
    }
  }

  ProductChange(data, param) {
    if (param == "drop") {
      var data = this.ProductsMappedInfoList.filter(x => x.value == data)[0];
      if (data != null && data != undefined) {
        this.fullFillmentTypeOptions = [];
        this.fullFillmentTypeOptions = [{ "label": "Partner Network", "value": 2 }];
        this.fullFillmentTypeOptions = [{ label: "Select", value: null, checked: true }].concat(this.fullFillmentTypeOptions);

        if (data.ISAllowShipmentToReporter) {
          this.fullFillmentTypeOptions.push({ "label": "Shipping Address", "value": 1 });
        }
        this.SelectedProductsMappedInfoList = data.MappedNetworks;
        this.ProductRequestForm.controls["ShippingInstractionsIfAny"].setValue(data.StorageInstructions);
        this.ProductRequestForm.controls["RequiredQuantityUnits"].setValue(data.ProductUnits);
        this.ProductRequestForm.controls["AllocatedQuantityUnits"].setValue(data.ProductUnits);
        this.ProductRequestForm.controls["UsedQuantityUnits"].setValue(data.ProductUnits);
        this.ProductRequestForm.controls["ReturnQuantityUnits"].setValue(data.ProductUnits);
        //this.ProductRequestForm.controls["ShippingInstractionsIfAny"].disable();
        this.ProductRequestForm.controls["RequiredQuantityUnits"].disable();
        this.ProductRequestForm.controls["AllocatedQuantityUnits"].disable();
        this.ProductRequestForm.controls["UsedQuantityUnits"].disable();
        this.ProductRequestForm.controls["ReturnQuantityUnits"].disable();
      }
    }
    else {
      this.FullfillmentChange(param);
    }

  }

  FullfillmentChange(data) {
    if (data == 1) {
      this.ProductshippingAddressOptions = this.shippingAddressOptions;
    }
    else if (data == 2) {
      this.ProductshippingAddressOptions = this.SelectedProductsMappedInfoList;
      this.ProductshippingAddressOptions = [{ label: "Select", value: null, checked: true }].concat(this.ProductshippingAddressOptions);
    } else {
      this.ProductshippingAddressOptions = [];
      this.ProductRequestForm.controls["ShippingAddress"].setValue("");
    }
  }

  BillingAddressChange(data1) {
    var data = this.shippingAddressOptions.filter(x => x.value == data1)[0];
    var addressList = [];
    if (data != null && data != undefined) {
      addressList = data.label.split(",");
    }
    this.billingAddress = new Object();
    this.billingAddress["Address"] = "";
    this.billingAddress["City"] = "";
    this.billingAddress["State"] = "";
    this.billingAddress["Country"] = "";
    this.billingAddress["PostalCode"] = "";
    if (addressList.length > 0) {
      this.billingAddress["Address"] = addressList[0];
      this.billingAddress["City"] = addressList[1];
      this.billingAddress["State"] = addressList[2];
      this.billingAddress["Country"] = addressList[3];
      this.billingAddress["PostalCode"] = addressList[4];
    }
  }

  SelectWeek(option) {
    if (this.SelectedWeeksList.indexOf(option) == -1) {
      this.SelectedWeeksList.push(option);
    }
    else {
      var index = this.SelectedWeeksList.indexOf(option);
      this.SelectedWeeksList.splice(index, 1);
    }
  }

}
